export const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DATE_CUBOH_INCEPTION = '2018-01-01 12:00:00 am';
export const DATE_CN_INCEPTION = '2019-01-01 12:00:00 am';
export const MIN_CLOSURE_DATE = '2024-01-01';

// Formats
export const DATE_MONTH_DAY = 'MMM DD';
export const DATE_ISO = 'YYYY-MM-DD';
export const DATE_MDY = 'MM/DD/YY';
export const DATE_MDY_FULL = 'MM/DD/YYYY';
export const DATE_YMD = 'YYYY/MM/DD';
export const DATE_12_HOUR_FORMAT_MDY = 'hh:mm A, MM/DD/YYYY';
export const DATE_12_HOUR_NO_LEADING_ZERO = 'h:mm A, MM/DD/YYYY';
export const FULL_DATE_12_HOUR_FORMAT = 'YYYY/MM/DD hh:mm:ss a';
export const FULL_DATE_24_HOUR_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_HOUR_FORMAT = 'hh:mm:ss a';
export const LOCAL_LAST_SAVE_DATE = 'MMMM Do YYYY, h:mm:ss a';
export const DATE_TIME_PICKER_FORMAT = 'MM/DD/YYYY hh:mm A';
export const TIME_PICKER_FORMAT = '12h';
export const TIME_24_HOUR_FORMAT = 'HH:mm';

// Dimensions
export const TODAY = 'Today';
export const LAST_SEVEN_DAYS = 'Last 7 Days';
export const THIS_MONTH = 'This Month';
export const THIS_YEAR = 'This Year';
export const LAST_YEAR = 'Last Year';

export const MIDNIGHT = '00:00';
export const ALWAYS_OPEN_TIME = '23:59';
